import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";

import { startSpinner, finishSpinner } from "../ui/spinner";

const movimientosTraerStart = () => ({
  type: types.movimientosTraerStart,
});
export const movimientosLimpiar = () => ({
  type: types.movimientosLimpiar,
});
export const movimientosTraerSuccess = (payload) => {
  return {
    type: types.movimientosTraerSuccess,
    payload: payload,
  };
};

export const traerMovimientos = () => {
  return async (dispatch,getState) => {
    dispatch(startSpinner());
    dispatch(movimientosTraerStart());
    const { afiliado, consultaAfiliado } = getState().afiliacion;
    const response = await fetchConToken(`Logs/${afiliado.id_afiliado ? afiliado.id_afiliado : consultaAfiliado.id_afiliado}`)
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      dispatch(movimientosTraerSuccess(lista))
    }
    dispatch(finishSpinner());
  };
};

